import React from 'react';

interface AutoInputIconProps {
    fill?: string;
}
export const AutoInputIcon = ({ fill = 'black' }: AutoInputIconProps) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
        >
            <g clipPath="url(#clip0_6001_51736)">
                <path
                    d="M14 0H2C1.46957 0 0.960859 0.210714 0.585786 0.585786C0.210714 0.960859 0 1.46957 0 2L0 16H16V2C16 1.46957 15.7893 0.960859 15.4142 0.585786C15.0391 0.210714 14.5304 0 14 0ZM14.6667 14.6667H1.33333V2C1.33333 1.82319 1.40357 1.65362 1.5286 1.5286C1.65362 1.40357 1.82319 1.33333 2 1.33333H14C14.1768 1.33333 14.3464 1.40357 14.4714 1.5286C14.5964 1.65362 14.6667 1.82319 14.6667 2V14.6667Z"
                    fill={fill}
                />
                <path
                    d="M8.75283 12.1416V10.8085H5.6953L9.93794 6.56587L8.99514 5.62307L4.75249 9.86571L4.7525 6.80818L3.41936 6.80818L3.41936 10.8085C3.41942 11.1621 3.55989 11.5011 3.80989 11.7511C4.05989 12.0011 4.39894 12.1416 4.75249 12.1416L8.75283 12.1416Z"
                    fill={fill}
                />
                <path
                    d="M6.80918 3.42085L6.80918 4.75399L9.86671 4.75399L5.62407 8.99663L6.56688 9.93944L10.8095 5.69679L10.8095 8.75432L12.1426 8.75432L12.1426 4.75399C12.1426 4.40043 12.0021 4.06138 11.7521 3.81138C11.5021 3.56138 11.1631 3.42091 10.8095 3.42085L6.80918 3.42085Z"
                    fill={fill}
                />
            </g>
            <defs>
                <clipPath id="clip0_6001_51736">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
